// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3set1","savePackageButton":"ClientWallet_savePackageButton__22FK4"};